import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useAppSelector } from '../../hooks/index';
import { Toast, ToastBody, ToastHeader, Table, Row, Col, Input, Label, Button, CardBody, FormFeedback, CardTitle, Card } from 'reactstrap';
import { Afr, getSelectedAfr, getEventList, EventGeneric, pullEventList, ValidationError } from '../../redux/AfrSlice';
import dateHelper from '../../utils/dateHelper';


const ValidationErrorList = function (props:
    {
        errorsToShow: Array<ValidationError> | null,
        title: string | null
    }) {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrEvents: Array<EventGeneric> = useAppSelector(pullEventList);

    var errors: Array<ValidationError> | null = props.errorsToShow ? props.errorsToShow : [];

    const [errorList, setErrorList] = useState<any>(errors);
    const componentTitle = props.title ? props.title : "Errors";


    useEffect(function () {
        if (props.errorsToShow) {
            setErrorList(props.errorsToShow);
        } else {
            setErrorList(null);
        }

    }, [props.errorsToShow]);


    return (
        <div>
            <Row>
                <Col md="10">
                    <Toast className="auditDetail">
                        <ToastHeader className="auditDetail">{componentTitle}</ToastHeader>
                        <ToastBody>
                            <div className="scrollable-table">
                                <Table className="table" >
                                    <thead className="scrollable-table-header thead-dark">
                                        <tr>
                                            <th>Severity</th>
                                            <th>Category</th>
                                            <th>Error</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {errorList.map((option: any, idx: any) => (
                                            <tr>
                                                <td>{option.severity}</td>
                                                <td>{option.category}</td>
                                                <td>{option.message}</td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                            </div>
                        </ToastBody>

                    </Toast>
                </Col>

            </Row>

        </div>
    )

}

export default ValidationErrorList;